export enum BiUpdateType {
  ADD = 0,
  CHANGE = 1,
}

export enum ReferralType {
  FAVOURITE = 'favourite',
  ADD_TO_PRIVATE_COLLECTION = 'add_to_private_collection',
  ADD_TO_GROUP = 'add_to_group',
  ADD_SUBFOLDER = 'add_sub_folder',
  WATCH = 'watch',
  EDIT_DEVIATION = 'edit_deviation',
  DELETE_DEVIATION = 'delete_deviation',
  MATURE = 'mature',
  ANTISOCIAL = 'members_only_art_viewing',
  POLL_VOTE = 'poll_vote',
  GIVE = 'give',
  DONATE_POINTS = 'donate_points',
  SUBMIT = 'submit',
  COMMENT_ACTION = 'comment_action',
  REPORT = 'report',
  NOTE = 'note',
  CHAT = 'chat',
  COMMENT = 'comment',
  EMPTY_COMMENT = 'empty_comment',
  HEADER = 'header',
  LOGIN = 'login',
  ANON_DOWNLOAD = 'anon_download',
  BACKGROUND_MODAL = 'background_modal',
  USER_STATS = 'user_stats',
  CUSTOM_BOX = 'custom_box',
  USER_SYMBOL_POPUP = 'user_symbol_popup',
  USER_SYMBOL_POPUP_EXTEND = 'user_symbol_popup_extend',
  SISU_FUNNEL_BANNER = 'sisu_funnel_banner',
  SISU_FUNNEL_NEXT_DEVIATION = 'next_deviation',
  BADGE_GET_FRAGMENTS = 'badge_get_fragments',
  ANON_NETWORKBAR = 'anon_networkbar',
  CREATE_COMMISSION = 'create_commission',
  CREATE_GALLERY = 'create_gallery',
  RECENT_VISITORS = 'recent_visitors',
  JOIN_GROUP = 'join_group',
  BILLING_PAYMENTS = 'billing_payments',
  CORE_BILLING_PAYMENTS = 'core_billing_payments',
  PURCHASE_HISTORY_BILLING_PAYMENTS = 'purchase_history_billing_payments',
  UPGRADE_CORE_BILLING_PAYMENTS = 'upgrade_core_billing_payments',
  ART_THEFT_DETECTION = 'art_theft_detection',
  MEMBER_SUBSCRIBE = 'member_subscribe',
  COMPARE_TIER_UNIQUE = 'compare_tier_unique',
  COMPARE_CONTENT_PAGE = 'compare_content_page',
  HOME_WIDGET = 'home_widget',
  ACTION_BAR = 'action_bar',
  PROMOTION_HOME = 'promotion_home',
  PROMOTION_DYW = 'promotion_dyw',
  SIDE_BAR_TIER_UNIQUE = 'side_bar_tier_unique',
  SIDE_BAR_CONTENT_PAGE = 'side_bar_content_page',
  SITE_FOOTER = 'site_footer',
  SUBSCRIPTIONS = 'subscriptions',
  SUBSCRIPTIONS_GO_LIVE = 'subscriptions_go_live',
  SUBSCRIPTIONS_TIER_CREATION = 'subscriptions_tier_creation',
  SUBSCRIPTIONS_TIER_DRAFT = 'subscriptions_tier_draft',
  TIER_UNIQUE = 'tier_unique',
  TIER_MODAL = 'tier_modal',
  CONTENT_PAGE = 'content_page',
  SUBSCRIPTIONS_WIDGET = 'subscriptions_widget',
  LOCKED_CONTENT = 'locked_content',
  TIER_CARD = 'tier_card',
  DAPROTECT_OFF = 'daprotect_off',
  DAPROTECT_TEMP = 'daprotect_temp',
  PAYWALL_WATCHERS_ONLY = 'paywall_watchers_only',
  PAYWALL_PG = 'paywall_pg',
  PAYWALL_PCP = 'paywall_pcp',
  PROMOTION_BANNER_USERMENU = 'promotion_banner_usermenu',
  PROMOTION_BANNER_CONTENT_PAGE = 'promotion_banner_content_page',
  PROMOTION_BANNER_HOME = 'promotion_banner_home',
  PROMOTION_BANNER_PROFILE = 'promotion_banner_profile',
  PROMOTION_BANNER_WATCH = 'promotion_banner_watch',
  PROMOTION_BANNER_DREAMUP = 'promotion_banner_dreamup',
  SIDEBAR_PROMOTION = 'sidebar_promotion',
  ART_STAGE_PROMOTION = 'art_stage_promotion',
  PROFILE_COVER_PROMOTION = 'profile_cover_promotion',
  PROFILE_SUBSCRIPTIONS = 'profile_subscriptions',
  PRIVATE_COLLECTIONS_SECTION = 'profile_private_collections_section',
  PRIVATE_COLLECTIONS_POPUP = 'private_collections_poup',
  SUBSCRIPTIONS_CORE_EXPIRED = 'subscriptions_core_expired',
  DYW_BIRTHDAY = 'dyw_birthday',
  HOMEPAGE_PROMOTION = 'homepage_promotion',
  PROTECT_LEFT = 'protect_left',
  PROTECT_TOP_BANNER = 'protect_top_banner',
  PROTECT_LIMIT_SPACE = 'protect_limit_space',
  SHARE_TO_POST = 'share_to_post',
  AWARD_BADGE = 'award_badge',
  SHOP_PREMIUM_GALLERIES = 'shop_premium_galleries',
  SHOP_PREMIUM_DOWNLOADS = 'shop_premium_downloads',
  SHOP_ADOPTABLES = 'shop_adoptables',
  WIDGET_PAYWALL_OVERLAY = 'widget_paywall_overlay',
  WIDGET_PAYWALL_PREVIEW = 'widget_paywall_preview',
  DEVIATION_WIDGET_PAYWALL_OVERLAY = 'deviation_widget_paywall_overlay',
  DEVIATION_WIDGET_PAYWALL_PREVIEW = 'deviation_widget_paywall_preview',
  LLAMAFARM_WIDGET_PAYWALL_OVERLAY = 'llamafarm_widget_paywall_overlay',
  LLAMAFARM_WIDGET_PAYWALL_PREVIEW = 'llamafarm_widget_paywall_preview',
  BADGES_SPOTLIGHT_PAYWALL_OVERLAY = 'badges_spotlight_paywall_overlay',
  BADGES_SPOTLIGHT_PAYWALL_PREVIEW = 'badges_spotlight_paywall_preview',
  PROFILE_SKINS = 'profile_skins',
  PROFILE_SUBNAV = 'profile_subnav',
  CONTACT_US = 'contact_us',
  DREAMUP_LEFT = 'dreamup_left',
  DREAMUP_LEFT_NO_PROMPTS = 'dreamup_left_no_prompts',
  DREAMUP_TOP_CREATE = 'dreamup_top_create',
  DREAMUP_CORE_UPSELL = 'dreamup_core_upsell',
  NSFG = 'nsfg',
  ANON_JOIN_NOTIFICATION = 'anon_join_notification',
  SELL_DEVIATION = 'sell_deviation',
  SELL_DEVIATION_DREAMUP = 'sell_deviation_dreamup',
  TOPIC_WATCH_CHANGE = 'topic_watch_change',
  WATCH_BIRTHDAY = 'watch_birthday',
  BADGES_LOG_HYPE = 'badges_log_hype',
  STUDIO_MULTI_SUBMIT = 'studio_multi_submit',
  STUDIO_MULTI_SUBMIT_TOOLTIP = 'studio_multi_submit_tooltip',
  STUDIO_MULTI_SUBMIT_LIMIT = 'studio_multi_submit_limit',
  STUDIO_BATCH_ACTION = 'studio_batch_action',
  STUDIO_BATCH_TIER = 'studio_batch_tier',
  STUDIO_BATCH_SCHEDULE = 'studio_batch_schedule',
  STUDIO_SIZE_LIMIT_TOOLTIP = 'studio_size_limit_tooltip',
  STUDIO_SCHEDULED_TAB = 'studio_scheduled_tab',
  STUDIO_ANALYTICS = 'studio_analytics',
  SUBMIT_SELL_SECTION = 'submit_sell_section',
  SUBMIT_VIDEO = 'submit_video',
  STUDIO_SCHEDULE = 'studio_schedule',
  STUDIO_HOME_BOOST = 'studio_home_boost',
  STUDIO_HOME_AWARD_BADGE = 'studio_home_award_badge',
  STUDIO_HOME_DREAMUP = 'studio_home_dreamup',
  HIDE_PROMPT = 'hide_prompt',
  DREAMUP_SPEND_UPSCALE_CONFIRMATION = 'upscale_confirmation',
  DREAMUP_SPEND_REMOVE_BG_CONFIRMATION = 'remove_bg_confirmation',
  CORE_CYCLE_PICKER = 'core_cycle_picker',
  BOOST_DEVIATION_POPUP = 'boost_deviation_popup',
  BOOST_UPGRADE_CORE_POPUP = 'boost_upgrade_core_popup',
  SUBMIT_MULTI_IMAGE_LIMIT = 'submit_multi_image_limit',
  MURO_MY_DRAWINGS = 'muro_my_drawings',
  GIFT_ADOPTABLE = 'gift_adoptable',
  MURO_CORE_UPGRADE = 'muro_core_upgrade',
  MURO_CORE_MANAGE = 'muro_core_manage',
  MURO_CORE_CTA = 'muro_core_cta',
  MURO_BG_CORE_UPGRADE = 'muro_background_core_upgrade',
  MURO_BG_CORE_MANAGE = 'muro_background_core_manage',
  MURO_BG_CORE_CTA = 'muro_background_core_cta',
  DRAW = 'draw',
  AVAILABLE_DISCOUNTS = 'available_discounts',
  MESSAGES = 'messages',
  MESSAGES_CREATE_CHANNEL = 'messages_create_channel',
  MESSAGES_ADD_TO_CHANNEL = 'messages_add_to_channel',
  GALLERY_DISPLAY_SETTINGS = 'gallery_display_settings',
  ORIGINAL_SUBMIT = 'original_submit',
  CHANGE_USERNAME = 'change_username',
  TWO_FACTOR_AUTH = '2fa',
}

export enum ScamLevelType {
  SCAM_LEVEL_NATIVE = 'native',
  SCAM_LEVEL_SAFE = 'safe',
  SCAM_LEVEL_WARN = 'warn',
  SCAM_LEVEL_DENY = 'deny',
}
